
import React from "react";
import { UpdateItem } from "./types";

interface UpdateTimelineItemProps {
  update: UpdateItem;
}

export function UpdateTimelineItem({ update }: UpdateTimelineItemProps) {
  return (
    <div className="relative pl-12">
      <div className="absolute left-[14px] top-1.5 w-2 h-2 rounded-full bg-[#1b9d3d]"></div>
      
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-[#1b9d3d]">
            {update.date}
          </span>
          {update.label === "Latest" && (
            <span className="px-2 py-0.5 text-xs font-medium bg-[#1b9d3d] text-white rounded-full">
              Nieuwste
            </span>
          )}
        </div>
        <h3 className="text-lg font-semibold">
          {update.title} {update.version}
        </h3>
        <p className="text-gray-600">
          {update.description}
        </p>
      </div>
    </div>
  );
}
